import { render, staticRenderFns } from "./SamTooltip.vue?vue&type=template&id=122344b4&scoped=true&shadow"
import script from "./SamTooltip.vue?vue&type=script&lang=js&shadow"
export * from "./SamTooltip.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamTooltip.vue?vue&type=style&index=0&id=122344b4&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "122344b4",
  null
  ,true
)

export default component.exports